<template>
  <div class="details">
    <!--    {{periodicalInfo}}-->
    <Left :detailsData="detailsData" />
    <Center
      :wenxian="wenxian"
      :type="type"
      :detailsData="detailsData.data"
      :columnList="detailsData.columnList && detailsData.columnList.data ? detailsData.columnList.data : []"
      :unitList="unitList"
    />
    <Right
      :autherList="autherList"
      :autherInfo="autherInfo"
      :type="type"
      :detailsData="detailsData"
      :periodicalInfo="periodicalInfo"
      :periodiID="periodiID"
    />
  </div>
</template>

<script>
import Left from "../components/left";
import Center from "./components/center";
import Right from "./components/right";
export default {
  name: "index",
  components: {
    Left,
    Center,
    Right,
  },
  data() {
    return {
      detailsData: {},
      autherInfo: {},
      type: null,
      wenxian: [],
      autherList: {},
      timeData: { informationCount: 0, thesisCount: 0 },
      periodicalInfo: {},
      periodiID: {},
      unitList: [],
    };
  },
  watch: {
    $route: {
      handler() {
        this.GetDetailsData();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getwenxian() {
      const { data } = await this.$apis.recomendServe.getwenxian({
        keyword: this.detailsData.data.keyword,
        pageNo: 1,
        pageSize: 5,
      });
      try {
        this.wenxian = data.list;
      } catch (e) {
        console.log(e);
      }
    },

    async getTable() {
      let res = await this.$apis.recomendServe.getTable();
      sessionStorage.setItem("Table", JSON.stringify(res));
    },
    async GetDetailsData() {
      let arr = {};
      if (sessionStorage.getItem("Table")) {
        arr = JSON.parse(sessionStorage.getItem("Table")).PlatformEnum;
      } else {
        await this.getTable();
        arr = JSON.parse(sessionStorage.getItem("Table")).PlatformEnum;
      }
      let PlatformEnumObj = {};
      arr.forEach((item) => {
        if (item.name === "中文知识网") {
          PlatformEnumObj = item;
        }
      });
      this.type = this.$router.history.current.query.type;
      const obj = {
        articleId: this.$router.history.current.query.id,
        articleType: this.$router.history.current.query.type,
        projectId: PlatformEnumObj.id,
      };
      const { data } = await this.$apis.recomendServe.getDetails(obj);
      this.detailsData = data;
      document.title = this.detailsData.data.title;
      let unitList = [];
      let firtUnit = this.detailsData.data.firstAuthorUnit.split(",");
      firtUnit.forEach((item) => unitList.push(item));
      if (this.detailsData.data.communicationAuthorUnit) {
        let communicationUnit = this.detailsData.data.communicationAuthorUnit.split(",");
        communicationUnit.forEach((item) => unitList.push(item));
      }
      if (this.detailsData.data.articleAuthorList) {
        this.detailsData.data.articleAuthorList.forEach((item) => {
          let arr = item.authorUnit.split(",");
          arr.forEach((item) => unitList.push(item));
        });
      }
      unitList = Array.from(new Set(unitList));
      this.unitList = unitList;
      await this.getwenxian();
    },
  },
};
</script>

<style lang="scss" scoped>
.details {
  width: 1300px;
  display: flex;
  //justify-content: space-between;
}
</style>
